import { render, staticRenderFns } from "./Crop2ML_WhatIsCrop2ML.vue?vue&type=template&id=77c9f883&scoped=true"
import script from "./Crop2ML_WhatIsCrop2ML.vue?vue&type=script&lang=js"
export * from "./Crop2ML_WhatIsCrop2ML.vue?vue&type=script&lang=js"
import style0 from "./Crop2ML_WhatIsCrop2ML.vue?vue&type=style&index=0&id=77c9f883&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c9f883",
  null
  
)

export default component.exports